import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
  import * as echarts from 'echarts/core';
  import { BarChart, HeatmapChart, LineChart, PieChart } from 'echarts/charts';
  import {
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
    VisualMapComponent,
  } from 'echarts/components';
  import { CanvasRenderer } from 'echarts/renderers';
  import type { ECharts, EChartsCoreOption } from 'echarts/core';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseChart',
  props: {
    option: {},
    height: { default: '320px' },
    width: { default: '100%' }
  },
  setup(__props: any) {

  echarts.use([
    BarChart,
    LineChart,
    PieChart,
    HeatmapChart,
    GridComponent,
    LegendComponent,
    TitleComponent,
    TooltipComponent,
    VisualMapComponent,
    CanvasRenderer,
  ]);

  const props = __props;

  const chartElement = ref<HTMLDivElement | null>(null);
  let chart: ECharts | null = null;
  let resizeObserver: ResizeObserver | null = null;

  const renderChart = async () => {
    await nextTick();
    if (!chartElement.value) return;
    if (!chart) chart = echarts.init(chartElement.value);
    chart.setOption(props.option, true);
  };

  watch(() => props.option, renderChart, { deep: true });

  onMounted(() => {
    renderChart();
    if (chartElement.value) {
      resizeObserver = new ResizeObserver(() => chart?.resize());
      resizeObserver.observe(chartElement.value);
    }
  });

  onBeforeUnmount(() => {
    resizeObserver?.disconnect();
    chart?.dispose();
    chart = null;
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "chartElement",
    ref: chartElement,
    class: "base-chart",
    style: _normalizeStyle({ width: _ctx.width, height: _ctx.height })
  }, null, 4))
}
}

})